/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Badge_SandboxInputs */

const id_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ms_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const da_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const de_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const en_us2_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const es_es2_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const es_mx2_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const fil_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const fr_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const it_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const hu_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const nl_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const no_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const pl_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const pt_br2_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const pt_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ro_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const fi_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiekkalaatikko`)
};

const sv_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandlåda`)
};

const vi_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const tr_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const cs_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const bg_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ru_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Песочница`)
};

const uk_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const ar_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

const hi_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सैंडबॉक्स`)
};

const th_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แซนด์บ็อกซ์`)
};

const ja_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンドボックス`)
};

const zh_cn2_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沙盒`)
};

const zh_hant1_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沙盒`)
};

const ko_home_pulse_badge_sandbox = /** @type {(inputs: Home_Pulse_Badge_SandboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox`)
};

/**
* | output |
* | --- |
* | "Sandbox" |
*
* @param {Home_Pulse_Badge_SandboxInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_badge_sandbox = /** @type {((inputs?: Home_Pulse_Badge_SandboxInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Badge_SandboxInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_badge_sandbox(inputs)
	if (locale === "ms") return ms_home_pulse_badge_sandbox(inputs)
	if (locale === "da") return da_home_pulse_badge_sandbox(inputs)
	if (locale === "de") return de_home_pulse_badge_sandbox(inputs)
	if (locale === "en-US") return en_us2_home_pulse_badge_sandbox(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_badge_sandbox(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_badge_sandbox(inputs)
	if (locale === "fil") return fil_home_pulse_badge_sandbox(inputs)
	if (locale === "fr") return fr_home_pulse_badge_sandbox(inputs)
	if (locale === "it") return it_home_pulse_badge_sandbox(inputs)
	if (locale === "hu") return hu_home_pulse_badge_sandbox(inputs)
	if (locale === "nl") return nl_home_pulse_badge_sandbox(inputs)
	if (locale === "no") return no_home_pulse_badge_sandbox(inputs)
	if (locale === "pl") return pl_home_pulse_badge_sandbox(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_badge_sandbox(inputs)
	if (locale === "pt") return pt_home_pulse_badge_sandbox(inputs)
	if (locale === "ro") return ro_home_pulse_badge_sandbox(inputs)
	if (locale === "fi") return fi_home_pulse_badge_sandbox(inputs)
	if (locale === "sv") return sv_home_pulse_badge_sandbox(inputs)
	if (locale === "vi") return vi_home_pulse_badge_sandbox(inputs)
	if (locale === "tr") return tr_home_pulse_badge_sandbox(inputs)
	if (locale === "cs") return cs_home_pulse_badge_sandbox(inputs)
	if (locale === "bg") return bg_home_pulse_badge_sandbox(inputs)
	if (locale === "ru") return ru_home_pulse_badge_sandbox(inputs)
	if (locale === "uk") return uk_home_pulse_badge_sandbox(inputs)
	if (locale === "ar") return ar_home_pulse_badge_sandbox(inputs)
	if (locale === "hi") return hi_home_pulse_badge_sandbox(inputs)
	if (locale === "th") return th_home_pulse_badge_sandbox(inputs)
	if (locale === "ja") return ja_home_pulse_badge_sandbox(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_badge_sandbox(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_badge_sandbox(inputs)
	return ko_home_pulse_badge_sandbox(inputs)
});
export { home_pulse_badge_sandbox as "home.pulse.badge.sandbox" }